var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"comp-doc-section ql-editor",style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.compProps.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }